import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UiBreadcrumbItem, UiNavSection, UiUserInfo } from '../../models/ui-sidebar.model';

@Component({
  selector: 'app-ui-page-shell',
  templateUrl: './ui-page-shell.component.html',
  styleUrls: ['./ui-page-shell.component.scss']
})
export class UiPageShellComponent {
  @Input() menuSections: UiNavSection[] = [];
  @Input() activePath = '';
  @Input() sidebarCollapsed = false;
  @Input() title = '';
  @Input() breadcrumbs: UiBreadcrumbItem[] = [];
  @Input() appName = 'SupplySync';
  @Input() user: UiUserInfo = { userName: 'Admin', companyName: '', initials: 'AD' };
  @Input() logoText = 'PA';
  @Input() companyName = 'Pradhan Associates';
  @Input() appSubtitle = 'SupplySync ERP';
  @Output() sidebarToggle = new EventEmitter<boolean>();
  @Output() navigate = new EventEmitter<string>();
  @Output() logout = new EventEmitter<void>();

  onSidebarToggle(): void {
    this.sidebarCollapsed = !this.sidebarCollapsed;
    this.sidebarToggle.emit(this.sidebarCollapsed);
  }

  onNavigate(path: string): void {
    this.navigate.emit(path);
  }

  onLogout(): void {
    this.logout.emit();
  }
}
